module.exports = __webpack_public_path__ + "static/media/USTC.ff4a1536.png";